// Create a vue app
import { createApp } from 'vue';
import PlannedTrails from "./PlannedTrails.vue";


if (document.getElementById('planned-trails') != null) {
  const app = createApp(PlannedTrails);
  app.mount('#planned-trails');
}
